
class GenericRALocalStorageStore {

    constructor(localStorageKey) {
        this.storageKey = localStorageKey;
    }

    async save(data) {

        console.log('Saving data to local storage', {data});
        var json = JSON.stringify(data);
        localStorage.setItem(this.storageKey, json);

        // Return in ra format
        return this.wrapForRA(data);

    }

    async read() {
        var json = localStorage.getItem(this.storageKey);
        console.log('Loaded local storage data', {json});

        json = json ? JSON.parse(json) : {};

        // For react admin single entity store
        json.id = 'undefined';

        return this.wrapForRA(json);
    }

    async remove() {
        var json = localStorage.removeItem(this.storageKey);
        return this.wrapForRA({})
    }

    wrapForRA(record) {
        var data = {data: record}
        return new Promise((resolve, reject) => {
            resolve(data)
        });
    }

}

export default GenericRALocalStorageStore;
